import { Link } from 'react-router';
import { cn } from '@dinewise/utils';
import type { QuickAction, QuickActionId } from './home.types.ts';
import { quickActionIcons } from './quick-action-icons.tsx';

const quickActionStyles = {
  'send-paylink': {
    card: 'bg-ande-olive-100 border-ande-olive-200',
    icon: 'text-ande-black',
  },
  'charge-card': {
    card: 'bg-ande-blue-50 border-ande-blue-100',
    icon: 'text-ande-black',
  },
} satisfies Record<QuickActionId, { card: string; icon: string }>;

type QuickActionCardProps = {
  action: QuickAction;
  to: string;
  className?: string;
};

export const QuickActionCard = ({ action, to, className }: QuickActionCardProps) => {
  const Icon = quickActionIcons[action.id];
  const styles = quickActionStyles[action.id];

  return (
    <Link
      to={to}
      className={cn(
        'flex min-h-[110px] flex-1 flex-col justify-between rounded-3xl border p-4 pb-5 text-left shadow-[0_2px_8px_rgba(0,0,0,0.06)]',
        styles.card,
        className,
      )}
    >
      <span
        className={cn(
          'flex size-11 items-center justify-center rounded-2xl bg-ande-surface-50',
          styles.icon,
        )}
      >
        <Icon />
      </span>
      <span className="mt-3 font-sans text-ande-black text-base leading-6">{action.label}</span>
    </Link>
  );
};
